import account from './asda-account.svg'
import addToList from './asda-add-to-list.svg'
import address from './asda-address.svg'
import alert from './asda-alert.svg'
import bag from './asda-bag.svg'
import barcode from './asda-barcode.svg'
import calendar from './asda-calendar.svg'
import camera from './asda-camera.svg'
import clickCollect from './asda-click-collect.svg'
import conversation from './asda-conversation.svg'
import cook from './asda-cook.svg'
import deliveryPass from './asda-delivery-pass.svg'
import events from './asda-events.svg'
import feedback from './asda-feedback.svg'
import groceries from './asda-groceries.svg'
import heartFilled from './asda-heart-filled.svg'
import heartOutlined from './asda-heart-outlined.svg'
import home from './asda-home.svg'
import list from './asda-list.svg'
import lock from './asda-lock.svg'
import lockers from './asda-lockers.svg'
import mail from './asda-mail.svg'
import map from './asda-map.svg'
import market from './asda-market.svg'
import mic from './asda-mic.svg'
import noAlcohol from './asda-no-alcohol.svg'
import orders from './asda-orders.svg'
import parkRide from './asda-park-ride.svg'
import payment from './asda-payment.svg'
import petrol from './asda-petrol.svg'
import pizza from './asda-pizza.svg'
import preferences from './asda-preferences.svg'
import printer from './asda-printer.svg'
import recipes from './asda-recipes.svg'
import settings from './asda-settings.svg'
import show from './asda-show.svg'
import trash from './asda-trash.svg'
import trolley from './asda-trolley.svg'
import truck from './asda-truck.svg'
import tube from './asda-tube.svg'
import voucher from './asda-voucher.svg'
import summer from './asda-summer.svg'
import support from './asda-support.svg'
import automatedCollection from './asda-automated-collection.svg'
import internalCollection from './asda-internal-collection.svg'
import mapPinChecked from './asda-map-pin-checked.svg'
import mapPinExpress from './asda-map-pin-express.svg'
import mapPinFilled from './asda-map-pin-filled.svg'
import mapPinOutlined from './asda-map-pin-outlined.svg'
import mapPinYourStore from './asda-map-pin-your-store.svg'
import nearMeFilled from './asda-near-me-filled.svg'
import nearMeOutlined from './asda-near-me-outlined.svg'
import starFilled from './asda-star-filled.svg'
import starHalfFilled from './asda-star-half-filled.svg'
import starOutlined from './asda-star-outlined.svg'
import thumbsDownFilled from './asda-thumbs-down-filled.svg'
import thumbsDownOutlined from './asda-thumbs-down-outlined.svg'
import thumbsUpFilled from './asda-thumbs-up-filled.svg'
import thumbsUpOutlined from './asda-thumbs-up-outlined.svg'
import verticalArrowSmall from './asda-vertical-arrow-small.svg'
import favList from './asda-fav-list.svg'

export default {
  account,
  addToList,
  address,
  alert,
  bag,
  barcode,
  calendar,
  camera,
  conversation,
  cook,
  events,
  feedback,
  groceries,
  home,
  list,
  lock,
  lockers,
  mail,
  map,
  market,
  mic,
  orders,
  parkRide,
  payment,
  petrol,
  pizza,
  preferences,
  printer,
  recipes,
  settings,
  show,
  summer,
  support,
  trash,
  trolley,
  truck,
  tube,
  voucher,
  'automated-collection': automatedCollection,
  'click-collect': clickCollect,
  'delivery-pass': deliveryPass,
  'heart-filled': heartFilled,
  'heart-outlined': heartOutlined,
  'internal-collection': internalCollection,
  'map-pin-checked': mapPinChecked,
  'map-pin-express': mapPinExpress,
  'map-pin-filled': mapPinFilled,
  'map-pin-outlined': mapPinOutlined,
  'map-pin-your-store': mapPinYourStore,
  'near-me-filled': nearMeFilled,
  'near-me-outlined': nearMeOutlined,
  'no-alcohol': noAlcohol,
  'star-filled': starFilled,
  'star-half-filled': starHalfFilled,
  'star-outlined': starOutlined,
  'thumbs-down-filled': thumbsDownFilled,
  'thumbs-down-outlined': thumbsDownOutlined,
  'thumbs-up-filled': thumbsUpFilled,
  'thumbs-up-outlined': thumbsUpOutlined,
  'vertical-arrow-small': verticalArrowSmall,
  'fav-list': favList,
}



// WEBPACK FOOTER //
// ./common/components/icon/system/index.js